import {
  RETIRE_EARLIER_THAN_YOUR_PEERS,
  PLAN_YOUR_CHILDS_FUTURE,
  BUY_LIFES_LITTLE_HAPPINESS,
} from './funds';

export const GOAL_BASED = [
  RETIRE_EARLIER_THAN_YOUR_PEERS,
  PLAN_YOUR_CHILDS_FUTURE,
  BUY_LIFES_LITTLE_HAPPINESS,
];



// WEBPACK FOOTER //
// ./constants/fundBuckets/goalBased.ts